/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * (tsType: Omit<EvaluationComment, \'id\'>, schemaOptions: { title: \'NewEvaluationComment\', exclude: [ \'id\' ] })
 */
export interface NewEvaluationComment { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    surveyId?: string;
    comment: string;
    commentType?: string;
    evaluationId?: string;
}

